module.exports = __webpack_public_path__ + "assets/tapAndSaveIcon-99086e.svg";